<!--
 * @Author: cryi.liu
 * @Date: 2020-05-28 16:27:55
 * @LastEditTime: 2020-07-17 16:02:24
 * @Description: 考试对象
-->
<template>
  <div class="exam-object">
    <p class="title">所选考试对象：</p>
    <i-table :columns="columns" :data="realData" border />
    <p class="scope-total">总计：{{ total }}人</p>
  </div>
</template>

<script>
export default {
  name: 'ExamObject',
  props: {
    paperScope: { type: Object, required: true },
  },
  data() {
    return {
      columns: [
        {
          title: '员工类型',
          key: 'staffType',
          align: 'center',
        },
        {
          title: '分公司',
          key: 'branch',
          align: 'center',
        },
        {
          title: '办事处',
          key: 'subBranch',
          align: 'center',
        },
        {
          title: '渠道',
          key: 'channel',
          align: 'center',
        },
        {
          title: '小渠道',
          key: 'compoChannel',
          align: 'center',
        },
        {
          title: '用户组',
          key: 'groupName',
          align: 'center',
        },
        {
          title: '身份类别',
          key: 'userType',
          align: 'center',
        },
        {
          title: '身份类别明细',
          key: 'userTypeDetail',
          align: 'center',
        },
        {
          title: '星级',
          key: 'starLevel',
          align: 'center',
        },
        {
          title: '主营产品',
          key: 'hrMainGroup',
          align: 'center',
        },
        {
          title: '人数',
          key: 'count',
          align: 'center',
        },
      ],
      realData: [],
      total: 0,
    };
  },
  watch: {
    paperScope: {
      immediate: true,
      handler(scope) {
        this.total = scope.total;

        if (scope.type === 'Excel') {
          this.realData = [
            {
              staffType: '--',
              branch: '--',
              subBranch: '--',
              channel: '--',
              compoChannel: '--',
              userType: '--',
              userTypeDetail: '--',
              starLevel: '--',
              hrMainGroup: '--',
              groupName: '--',
              count: scope.total,
            },
          ];
        } else if (scope.type === 'Scope') {
          const scopeList = scope.list;

          scopeList.forEach((item) => {
            if (item.dispatched) {
              item.staffType = '第三方员工';

              if (!item.branch) {
                item.branch = '所有分公司';
              }

              if (!item.subBranch) {
                item.subBranch = '所有办事处';
              }

              if (!item.channel) {
                item.channel = '所有渠道';
              }

              if (!item.compoChannel) {
                item.compoChannel = '所有小渠道';
              }

              if (!item.userType) {
                item.userType = '所有';
              }

              if (!item.userTypeDetail) {
                item.userTypeDetail = '所有';
              }

              if (!item.starLevel) {
                item.starLevel = '所有';
              }

              if (!item.mainGroup) {
                item.hrMainGroup = '所有主营产品';
              }

              if (!item.groupName) {
                item.groupName = '--';
              }
            } else {
              item.staffType = '非第三方员工';

              if (!item.branch) {
                item.branch = '所有分公司';
              }

              if (!item.subBranch) {
                item.subBranch = '所有办事处';
              }

              if (!item.channel) {
                item.channel = '所有渠道';
              }

              if (!item.compoChannel) {
                item.compoChannel = '所有小渠道';
              }

              if (!item.userType) {
                item.userType = '--';
              }

              if (!item.userTypeDetail) {
                item.userTypeDetail = '--';
              }

              if (!item.starLevel) {
                item.starLevel = '--';
              }

              if (!item.mainGroup) {
                item.hrMainGroup = '--';
              }

              if (!item.groupName) {
                item.groupName = '所有用户组';
              }
            }
          });

          this.realData = scopeList;
        }
      },
    },
  },
};
</script>

<style lang="less" scoped>
.exam-object {
  width: 100%;

  > .title {
    margin-bottom: 12px;
    font-weight: bold;
  }

  > .scope-total {
    display: flex;
    justify-content: flex-end;
    font-weight: bold;
    font-size: 12px;
    padding: 4px;
  }
}
</style>
